// Generated by render-release-build.mjs; excluded from the input fingerprint.
export const RENDER_RELEASE = {"format":1,"fingerprint":"2b62815fde6e2f48bdc4fff440f81ad0843cad04513d8882d7fc19f20d454967"} as const;
